import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Store } from "pullstate";
import GlobalStore from "../utils/Store";
import servicesUtils from "../utils/servicesUtils";
import Toast from "../components/Toast";
var CsvUploadStore = new Store({
  view: "upload",
  result: null,
  local: null
});
function reducer(action) {
  if (action.type === "submit-for-validation") {
    var _action$payload = action.payload,
      file = _action$payload.file,
      selectedWorkspace = _action$payload.selectedWorkspace;
    var formData = new FormData();
    formData.append("file", file);
    var workspaceId = selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.value;
    var URL = "workspaces/".concat(workspaceId, "/patients/generate_report_summary/");
    CsvUploadStore.update(function (s) {
      s.view = "loading";
    });
    servicesUtils.postService(URL, formData).then(function (res) {
      CsvUploadStore.update(function (s) {
        s.view = "validate";
        s.result = {
          data: _objectSpread(_objectSpread({}, res), {}, {
            file: file
          }),
          success: true
        };
        s.local = {
          selectedWorkspace: selectedWorkspace,
          filePath: res.file_path,
          newPatients: res.new_patient_reports
        };
      });
    })["catch"](function (err) {
      CsvUploadStore.update(function (s) {
        s.view = "validation-error";
        s.result = {
          data: {
            message: err.response.data.error
          }
        };
      });
    });
  } else if (action.type === "reset") {
    CsvUploadStore.update(function (s) {
      s.view = "upload";
      s.result = null;
    });
  } else if (action.type === "upload") {
    var state = CsvUploadStore.getRawState();
    if (state.local) {
      var _state$local = state.local,
        filePath = _state$local.filePath,
        _selectedWorkspace = _state$local.selectedWorkspace,
        newPatients = _state$local.newPatients;
      var _workspaceId = _selectedWorkspace === null || _selectedWorkspace === void 0 ? void 0 : _selectedWorkspace.value;
      var _URL = "workspaces/".concat(_workspaceId, "/patients/upload_report/");
      var body = {
        file_path: filePath
      };
      CsvUploadStore.update(function (s) {
        s.view = "loading";
      });
      servicesUtils.postService(_URL, body).then(function (res) {
        // hide the modal
        GlobalStore.update(function (s) {
          s.showCsvUploadModal = false;
        });
        // reset the local state
        reducer({
          type: "reset"
        });
        Toast.success("".concat(newPatients, " new patient registrations done"));
        // need to refresh the filters and refetch the count of patients
        GlobalStore.update(function (s) {
          s.refreshLCFilterCount = true;
        });
      })["catch"](function (err) {
        Toast.error("Unable to process the request");
      });
    }
  } else if (action.type === "get-logs") {
    var _selectedWorkspace2 = action.payload.selectedWorkspace;

    // CsvUploadStore.update((s) => {
    //   s.view = "loading";
    // });

    var _workspaceId2 = _selectedWorkspace2 === null || _selectedWorkspace2 === void 0 ? void 0 : _selectedWorkspace2.value;
    var _URL2 = "workspaces/".concat(_workspaceId2, "/upload_history/");
    servicesUtils.getService(_URL2).then(function (res) {
      CsvUploadStore.update(function (s) {
        s.view = "logs";
        s.result = {
          data: res
        };
      });
    })["catch"](function (err) {
      Toast.error("Error loading upload logs");
      CsvUploadStore.update(function (s) {
        s.view = "upload";
      });
    });
  } else if (action.type === "show-logs-view") {
    CsvUploadStore.update(function (s) {
      s.view = "logs";
      s.local = null;
      s.result = null;
    });
  }
}
function useCsvUpload() {
  var state = CsvUploadStore.useState(function (s) {
    return s;
  });
  return [state, reducer];
}
export default useCsvUpload;